import ReactDom from 'react-dom';

import BackIconImage from '@assets/svg/back-icon.svg';
import { useState } from 'react';

import { StateMethods } from '@hookstate/core';
import { Overlay, Container, SpacingDivider, Back } from './CloneAsset.styles';
import { CloneAssetMenu } from './components';

interface ICloneAsset {
  open: boolean;
  onClose: () => void;
  openCloneAsset: StateMethods<boolean>;
}

export const CloneAsset = ({ open, onClose, openCloneAsset }: ICloneAsset) => {
  const portalDiv = document.getElementById('portal');

  const [topic, setTopic] = useState<'user' | null>(null);

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            {topic && (
              <>
                <Back
                  src={BackIconImage}
                  alt="back"
                  onClick={() => setTopic(null)}
                />
                <SpacingDivider />
              </>
            )}
            <CloneAssetMenu onClose={onClose} openCloneAsset={openCloneAsset} />
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
